const actions = {
  ADD: 'survey/ADD',
}

export default actions
